import { ContentMenuItemsEndpoint as ContentMenuItemsEndpointInterface } from '@apiClient/interfaces/endpoints/ContentMenuItems.endpoint';
import { buildSearchParams } from '@/utils/handlers/urlHandler';
import { KyInstance } from "ky/distribution/types/ky";
import { KyResponse } from 'ky';
import MenuItemsSearchDto from '@/projectRoot/api-client/interfaces/request/content/MenuItemsSearch.dto';
import ApiResponseDto from '@/projectRoot/api-client/interfaces/response/ApiResponse.dto';
import MenuItemDto from '@/projectRoot/api-client/interfaces/models/content/menu/MenuItem.dto';
import PaginationDto from '@/projectRoot/api-client/interfaces/request/Pagination.dto';

export class ContentMenuItemsEndpoint implements ContentMenuItemsEndpointInterface {
   
    private _httpClient: KyInstance;
    private cache: RequestCache;

    public constructor(client: KyInstance, cache: RequestCache = process.env.NEXT_PUBLIC_ENVIRONMENT == 'staging' ? "no-store" : "force-cache") {
        this._httpClient = client;
        this.cache = cache;
    }

    get httpClient(): KyInstance {
        if (!this._httpClient) {
            throw new Error('Ky http client is not initialized');
        }
        return this._httpClient;
    }

    set httpClient(kyInstance: KyInstance) {
        this._httpClient = kyInstance;
    }

    /**
    * Return found menu items, always ordered by parent_breadcrumbs and order field
    * /api/content/menu-items
    */
    async search(params?: MenuItemsSearchDto): Promise<ApiResponseDto<MenuItemDto[], PaginationDto>> {
        return this._httpClient
            .get(`content/menu-items`, { searchParams: buildSearchParams(params), cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    /**
    * Return found menu items, always ordered by parent_breadcrumbs and order field
    * /api/content/menu-items/{id}
    */
    async single(id: string): Promise<ApiResponseDto<MenuItemDto, undefined>> {
        return this._httpClient
            .get(`content/menu-items/${id}`, { cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }
}

export default ContentMenuItemsEndpoint;